
import {
  Box,
  Grid,
  Button,
  IconButton,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import { useState } from "react";
import DeleteOutlineIcon from "@mui/icons-material/Delete";
import TextFieldInput from "../../../../components/TextFieldInput";
import UploadInput from "../../../../components/UploadInput";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import UploadPopup from "../../../../shared-components/upload-popup/UploadPopup";
import { useDispatch, useSelector } from "react-redux";
import { removeBlobImages } from "../../../../utilis/common-funtions";
import { useRazorpayPayment } from "../../components/payments/useRazorpayPayment";
import {
  createRazorpayOrder,
  verifyVoucherPayment,
  deletePaymentDetails,
} from "../../voucher-form.slice";
import { formatDateIST } from "../../components/common-functions/PaymentCommonFunctions";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import PaymentCard from "../thank-you/PaymentCard";
import CustomDatePicker from "../../../../components/CustomDatePicker";
import { EOIFinanceStatus, EOIPaymentMode, FORM_PHASE,GATEWAY,getStatusStyles,MAX_TRANSACTION_LIMIT } from "../../../../config/constant";
import { useEasebuzzPayment } from "../payments/useEasebuzzPayment";
import PaymentFailedModal from "../../../new-booking-form/Individual-components/PaymentFailedModal";
import dayjs from "dayjs";
import ConfirmationModal from "../../../../shared-components/confirmation-modal/ConfirmationModal";

const MultiTransaction = ({ paymentOptionsFormik }) => {
  const { voucherId } = useParams();
  const [paymentIndex, setPaymentIndex] = useState("");
  const dispatch = useDispatch();

  const { applicantData, isUpgradePreferentialStep,eoiCampaignDetails } =
    useSelector((state) => state?.voucherForm);
  // eslint-disable-next-line no-unused-vars
  const [verifying, setVerifying] = useState(false);

  const [totalAmountPayable, setTotalAmountPayable] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [isPayViaEasebuzz,setIsPayViaEasebuzz] = useState(true)
  const [openPaymentFailedModal,setOpenPaymentFailedModal] = useState(false)
  const [failedAmount,setFailedAmount]= useState('')
  const [payButtonLoading,setPayButtonLoading]= useState(false)
  const [chequeDateWarningModal,setChequeDateWarningModal]= useState(false)

  const [imageState, setImageState] = useState([
    {
      id:"",
      paymentMethod: "", // online | offline
      offlineRadioOptions: "", // cheque/fundtransfer/card/edcMachine
      transactionNo: "",
      bankName: "",
      branchName: "",
      accountNo: "",
      amount: "",
      paymentProof: [],
      status:EOIFinanceStatus.UNVERIFIED, // pending | success
      date: null,
      type: "",
      isPaid: false,
      showUploadPopup: false,
      isPhysicalPaymentProof: false,
      email: "",
      onlineMethod: "",
      contact: "",
      orderId: "",
      gatewayPaymentId: "",
      paymentTransactionId: "",
    },
  ]);
  const { values, setFieldValue } = paymentOptionsFormik;
  const {
    initiatePayment,
    paymentResponse,
  } = useRazorpayPayment();

  const { initiateEasebuzzPayment, paymentResponse:easebuzzPaymentResponse } = useEasebuzzPayment()
  

  const handleImageValue = (txnIndex, keyName, imgName, close) => {
    removeBlobImages();

    const allTransactions = [...values.transactions];
    allTransactions[txnIndex] = {
      ...allTransactions[txnIndex],
      [keyName]: [...imgName],
      showUploadPopup: false,
      isPhysicalPaymentProof: false, // append new
    };
    setImageState(allTransactions);
  };

  const handlePhysicalImage = (txnIndex, keyName, value) => {
    const allTransactions = [...values.transactions];
    allTransactions[txnIndex] = {
      ...allTransactions[txnIndex],
      isPhysicalPaymentProof: value,
      showUploadPopup: false, // close popup after setting physical proof
    };
    setImageState(allTransactions);
  };

  useEffect(() => {
    paymentOptionsFormik.setFieldValue("transactions", imageState);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageState]);

  const handleUpdateImageData = (index, fieldName, imageData) => {
    setFieldValue(`transactions[${index}].paymentProof`, imageData);
    paymentOptionsFormik.setFieldValue(
      `transactions[${index}].paymentProof`,
      imageData
    );
  };

  const toggleTransactionScreenshot = (index) => {
    const updated = [...values.transactions];
    updated[index].showUploadPopup = !updated[index].showUploadPopup;
    setFieldValue("transactions", updated);
  };

  

  const handleRazorPay = async (amount, index) => {
    try {
      // 1. Create order
      const orderRes = await dispatch(
        createRazorpayOrder({
          amount: amount,
          entityType: "voucher",
          entityId: applicantData?.id?.toString(),      
          gateway: GATEWAY?.RAZORPAY,
          notes: {
            voucherId: voucherId,
            voucherAmount: totalAmountPayable,
            productInfo: applicantData?.uniqueReferenceId,
            guest: {
              name: `${applicantData?.applicant1?.personalDetails?.firstName} ${applicantData?.applicant1?.personalDetails?.lastName}`.trim(),
              email: applicantData?.applicant1?.personalDetails?.emailAddress,
              phone: applicantData?.applicant1?.personalDetails?.contactNumber,
            },
          },
        })
      ).unwrap();
      // 2. Open Razorpay popup
      initiatePayment({
        amount: orderRes?.razorpayOrder?.amount,
        currency: orderRes?.razorpayOrder?.currency,
        orderId: orderRes?.razorpayOrder?.id,
        name: "Puravankara",
        description: "Payment",
        prefill: {
          name: orderRes?.razorpayKey?.notes?.guest?.name,
          email: orderRes?.razorpayKey?.notes?.guest?.email,
          contact: orderRes?.razorpayKey?.notes?.guest?.phone,
        },
        razorpayKey: orderRes?.razorpayKey,
      });
    } catch (err) {
      console.error("Payment failed:", err);
    }

    setPaymentIndex(index);
  };

    const handleEasebuzzPay = async (amount,index) => {
      setPayButtonLoading(true)
      try {
        const orderRes = await dispatch(
          createRazorpayOrder({
            amount,
            entityType: "voucher",
            entityId:applicantData?.id?.toString(),
            gateway: GATEWAY?.EASEBUZZ,
            redirectUrl: window.location.href,
             notes: {
            voucherId: voucherId,
            voucherAmount: totalAmountPayable,
            productInfo: applicantData?.uniqueReferenceId,
            guest: {
              name: `${applicantData?.applicant1?.personalDetails?.firstName} ${applicantData?.applicant1?.personalDetails?.lastName}`.trim(),
              email: applicantData?.applicant1?.personalDetails?.emailAddress,
              phone: applicantData?.applicant1?.personalDetails?.contactNumber,
            },
          },
          })
        ).unwrap();

        if (orderRes) {
        setPayButtonLoading(false);
      }
  
        const orderAccessKey = orderRes.accessKey;
  
        if (!orderAccessKey) {
          throw new Error(
            "Backend did not return access_key. Check createRazorpayOrder response: " +
              JSON.stringify(orderRes)
          );
        }
  
        await initiateEasebuzzPayment({
          orderAccessKey,
          easebuzzKey:orderRes?.easebuzzKey
        });
        setPaymentIndex(index);
        setPayButtonLoading(false)

      } catch (err) {
        setPaymentIndex(index);
        setFailedAmount(amount);
        setOpenPaymentFailedModal(true);
        setPayButtonLoading(false);
        console.error("Failed to initiate payment:", err);
      }

    };

  useEffect(() => {
    if (!paymentResponse) return;
    let attempts = 0;
    let isVerified = false;
    setFailedAmount('');

    const verifyPayment = async () => {
      if (attempts === 0) setVerifying(true); // start loading
      attempts++;

      const res = await dispatch(
        verifyVoucherPayment({
          orderId: paymentResponse?.razorpay_order_id,
          paymentId: paymentResponse?.razorpay_payment_id,
          signature: paymentResponse?.razorpay_signature,
          gateway: GATEWAY?.RAZORPAY,
          clientResponse:JSON.stringify(paymentResponse)
        })
      );

      if (res?.payload?.status === "success") {
        isVerified = true;
        handlePaymentResponse(
          paymentIndex,
          res?.payload?.method,
          res?.payload?.date,
          res?.payload?.gatewayPaymentId
        );
        setVerifying(false); // stop loading on success
      } else if (attempts < 3 && !isVerified) {
        // retry after short delay
        setTimeout(verifyPayment, 2000);
      } else {
        // stop loading after all attempts fail
        setVerifying(false);
        // optionally update formik to failed status
        setFieldValue(
          `transactions[${paymentIndex}].status`,
          EOIFinanceStatus.UNVERIFIED
        );
      }
    };

    verifyPayment();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentResponse]);


  useEffect(() => {
    if (!easebuzzPaymentResponse) return;

    if (easebuzzPaymentResponse && easebuzzPaymentResponse?.status === "failure") {
      setFailedAmount(easebuzzPaymentResponse?.amount)
      setOpenPaymentFailedModal(true)
      return;
    }
    let attempts = 0;
    let isVerified = false;
    setFailedAmount('');

    const verifyPayment = async () => {
      if (attempts === 0) setVerifying(true); // start loading
      attempts++;

      const res = await dispatch(
        verifyVoucherPayment({
          orderId: easebuzzPaymentResponse?.txnid,
          paymentId: easebuzzPaymentResponse?.easepayid,
          signature: easebuzzPaymentResponse?.hash,
          gateway: GATEWAY?.EASEBUZZ,
          clientResponse:JSON.stringify(easebuzzPaymentResponse)
        })
      );

      if (res?.payload?.status === "success") {
        isVerified = true;
        handlePaymentResponse(
          paymentIndex,
          res?.payload?.method,
          res?.payload?.date,
          res?.payload?.gatewayPaymentId
        );
        setVerifying(false); // stop loading on success
      } else if (attempts < 3 && !isVerified) {
        // retry after short delay
        setTimeout(verifyPayment, 2000);
      } else {
        // stop loading after all attempts fail
        setVerifying(false);
        // optionally update formik to failed status
        setFieldValue(
          `transactions[${paymentIndex}].status`,
          "Verification Failed"
        );
      }
    };
    if (easebuzzPaymentResponse && easebuzzPaymentResponse?.status === "success") {
      verifyPayment();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [easebuzzPaymentResponse]);
  

  const handlePaymentResponse = (index, method, date, paymentId) => {
    setFieldValue(`transactions[${index}].isPaid`, true);
    setFieldValue(`transactions[${index}].status`, EOIFinanceStatus.VERIFIED);
    setFieldValue(`transactions[${index}].date`, date);
    setFieldValue(`transactions[${index}].onlineMethod`, method);
    setFieldValue(`transactions[${index}].gatewayPaymentId`, paymentId);
  };

  const getLabel = (option) => {
    switch (option) {
      case "CHEQUE":
        return {
          firstField: {
            label: "Cheque/DD Number",
            placeholder: "Enter Cheque/DD Number",
          },
          secondField: { label: "Bank Name", placeholder: "Enter Bank Name" },
          thirdField: {
            label: "Branch Name",
            placeholder: "Enter Branch Name",
          },
          fourthField: {
            label: "Account Number",
            placeholder: "Enter Account Number",
          },
        };
      case "ONLINE TRANSFER":
        return {
          firstField: {
            label: "Transaction ID",
            placeholder: "Enter Transaction ID",
          },
          secondField: { label: "Bank Name", placeholder: "Enter Bank Name" },
          thirdField: {
            label: "Branch Name",
            placeholder: "Enter Branch Name",
          },
          fourthField: {
            label: "Account Number",
            placeholder: "Enter Account Number",
          },
        };
      case "UPI CARD":
        return {
          firstField: {
            label: "Transaction ID",
            placeholder: "Enter Transaction ID",
          },
          secondField: { label: "Bank Name", placeholder: "Enter Bank Name" },
          thirdField: {
            label: "Branch Name",
            placeholder: "Enter Branch Name",
          },
          fourthField: {
            label: "Account Number",
            placeholder: "Enter Account Number",
          },
        };
      case "EDC MACHINE":
        return {
          firstField: {
            label: "Transaction ID",
            placeholder: "Enter EDC Transaction ID",
          },
          secondField: { label: "Bank Name", placeholder: "Enter Bank Name" },
          thirdField: {
            label: "Branch Name",
            placeholder: "Enter Branch Name",
          },
          fourthField: {
            label: "Account Number",
            placeholder: "Enter Account Number",
          },
        };
      default:
        return {
          firstField: {
            label: "Transaction ID",
            placeholder: "Enter Transaction ID",
          },
          secondField: { label: "Bank Name", placeholder: "Enter Bank Name" },
          thirdField: {
            label: "Branch Name",
            placeholder: "Enter Branch Name",
          },
          fourthField: {
            label: "Account Number",
            placeholder: "Enter Account Number",
          },
        };
    }
  };

  const handleAddTransaction = () => {
    if (paymentOptionsFormik?.values?.transactions?.length >= MAX_TRANSACTION_LIMIT) return;
    setFieldValue("transactions", [
      ...values.transactions,
      { id:"",
        paymentMethod: "", // online | offline
        offlineRadioOptions: "", // cheque/fundtransfer/card/edcMachine
        transactionNo: "",
        bankName: "",
        branchName: "",
        accountNo: "",
        amount: "",
        paymentProof: [],
        status:EOIFinanceStatus.UNVERIFIED, // pending | success
        date: null,
        type: "",
        isPaid: false,
        showUploadPopup: false,
        isPhysicalPaymentProof: false,
        email: "",
        onlineMethod: "",
        contact: "",
        orderId: "",
        gatewayPaymentId: "",
        paymentTransactionId: "",
      },
    ]);
  };

  const handleRemoveTransaction = (index, id) => {
    const updated = [...values.transactions];
    updated.splice(index, 1);
    if (id) {
      dispatch(
        deletePaymentDetails({
          voucherId: applicantData?.voucherId,
          paymentId: id,
        })
      )
        .unwrap() // gives direct access to fulfilled/rejected values
        .then((res) => {
          if(res.success){
            setFieldValue("transactions", updated);
          }
        })
        .catch((err) => {
          console.error("Delete failed:", err);
        });
    } else {
      setFieldValue("transactions", updated);
    }
  };

  const handleInputFilter = (e, index, key, type) => {
    let value = e?.target?.value || "";

    switch (type) {
      case "alphanumeric": // cheque/dd/txn no.
        value = value.replace(/[^a-zA-Z0-9]/g, "");
        break;
      case "alphabets": // bank & branch names
        value = value.replace(/[^a-zA-Z ]/g, "");
        break;
      case "numbers": // account no. & amount
        value = value.replace(/[^0-9]/g, "");
        break;
      case "noSpaces":
        value = value.replace(/ /g, "");
        break;
      default:
        break;
    }

    const updateArray = structuredClone(
      paymentOptionsFormik?.values?.transactions
    );

    // if (key === "amount") {
    //   // Convert to number safely
    //   let numericValue = parseFloat(value || 0);

    //   // Calculate total of other indices
    //   const restTotal = updateArray.reduce((sum, txn, idx) => {
    //     if (idx !== index) {
    //       return sum + (parseFloat(txn.amount) || 0);
    //     }
    //     return sum;
    //   }, 0);

    //   // Maximum allowed for current index
    //   const maxAllowed = totalAmountPayable - restTotal;

    //   // Restrict entered value
    //   if (numericValue > maxAllowed) {
    //     numericValue = maxAllowed;
    //   }

    //   updateArray[index][key] = numericValue;
    // } else {
    // }
    updateArray[index][key] = value;

    paymentOptionsFormik.setFieldValue("transactions", updateArray);
  };

  const getPayableAmount = () => {
    if (!applicantData || !eoiCampaignDetails) return "0";

    const { formPhase, eoiDetails } = applicantData;
    const eoiType = eoiDetails?.eoiType;

    if (formPhase === FORM_PHASE.VOUCHER) {
      if (!isUpgradePreferentialStep) return eoiCampaignDetails?.voucherAmount || "0";
    }
    if (formPhase === FORM_PHASE.EOI) {
      if (eoiType === "Preferential") return eoiCampaignDetails?.preEoiAmount || "0";
      if (eoiType === "Standard") return eoiCampaignDetails?.stdEoiAmount || "0";
    }

    return eoiCampaignDetails?.preEoiAmount || eoiCampaignDetails?.stdEoiAmount || eoiCampaignDetails?.voucherAmount ; // default fallback
  };

  useEffect(() => {
    const totalamount = getPayableAmount();
    setTotalAmountPayable(totalamount);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  
  function getTransactionTitle(index) {
    if (applicantData?.paymentDetails && index === 0) {
      return true;
    } else if (values?.transactions?.length > 1 && index === 0) {
      return true;
    } else if (index === 0) {
      return false;
    } else {
      return true;
    }
  }

  const handleProceedGateway = (selectedGateway) => {

    if (selectedGateway === GATEWAY?.RAZORPAY) {
      //setIsPayViaEasebuzz(false)
      handleRazorPay(failedAmount,paymentIndex)
      setFailedAmount('')
    }
    if (selectedGateway === GATEWAY?.EASEBUZZ) {
      //setIsPayViaEasebuzz(true)
      handleEasebuzzPay(failedAmount,paymentIndex)
      setFailedAmount('')
    }
    setOpenPaymentFailedModal(false)
  }

const handleDateChange = (dateValue, index, paymentOptions) => {
  setFieldValue(`transactions[${index}].date`, dateValue);

  if (paymentOptions === "CHEQUE" && dateValue) {
    const selectedDate = dayjs(dateValue);
    const tomorrow = dayjs().add(1, "day");

    // Show modal if selected date is greater than tomorrow
    if (selectedDate.isAfter(tomorrow, "day")) {
      setChequeDateWarningModal(true);
    }
  }
};
  return (
    <>
      {/* If no transactions, show Add Button */}
      {values?.transactions?.length === 0 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            color: "rgba(26, 64, 125, 1)",
          }}
        >
          <Button onClick={handleAddTransaction}>
            <ControlPointIcon sx={{ color: "rgba(26, 64, 125, 1)" }} />
            <Typography
              sx={{
                color: "rgba(26, 64, 125, 1)",
                fontSize: "14px",
                fontWeight: "600",
                textDecoration: "underline",
                textTransform: "none",
              }}
            >
              Add multiple transactions
            </Typography>
          </Button>
        </Box>
      )}

      {applicantData?.primarySource ? (
      <Grid container spacing={2} mb={2} ml={0}>
        <Grid item xs={6}>
          <Box sx={{ display: 'flex', alignItems: 'center'}}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500}}>
              Primary Source: &nbsp;
            </Typography>
            <Typography sx={{ fontSize: '14px'}}>
              {applicantData?.primarySource}
            </Typography>
          </Box>
        </Grid>
        {applicantData?.sourceDetails?.referredBy && (
        <Grid item xs={6}>
          <Box sx={{ display: 'flex', alignItems: 'center'}}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500}}>
              Referred By: &nbsp;
            </Typography>
            <Typography sx={{ fontSize: '14px'}}>
              {applicantData?.sourceDetails?.referredBy}
            </Typography>
          </Box>
        </Grid>
        )}
        {applicantData?.sourceDetails?.channelPartner && (
        <Grid item xs={6}>
          <Box sx={{ display: 'flex', alignItems: 'center'}}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500}}>
              CP Name: &nbsp;
            </Typography>
            <Typography sx={{ fontSize: '14px'}}>
              {applicantData?.sourceDetails?.channelPartner}
            </Typography>
          </Box>
        </Grid>
        )}
        {applicantData?.sourceDetails?.employeeName && (
        <Grid item xs={6}>
          <Box sx={{ display: 'flex', alignItems: 'center'}}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500}}>
              Employee Name: &nbsp;
            </Typography>
            <Typography sx={{ fontSize: '14px'}}>
              {applicantData?.sourceDetails?.employeeName}
            </Typography>
          </Box>
        </Grid>
        )}
      </Grid>
      ): null}

      {values?.transactions?.map((txn, index) => {
        const isDisabled = txn?.paymentMethod === EOIPaymentMode.OFFLINE && txn?.status === EOIFinanceStatus.VERIFIED
        const { bg, color, text } = getStatusStyles(txn?.status);

        return (
        <Box
          key={index}
          sx={{
            borderRadius: "12px",
            padding: "16px",
            marginBottom: "20px",
            position: "relative",
            border: "1px solid rgba(26, 64, 125, 0.3)",
          }}
        >
          {/* Delete Transaction */}
          {getTransactionTitle(index) && (
            <Grid container spacing={2} mb={3}>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: "14px", fontWeight: "700" }}>
                  Transaction {index + 1}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                {!txn?.isPaid && index !== 0 && (
                  <IconButton
                    onClick={() => handleRemoveTransaction(index, txn.id)}
                    sx={{ position: "absolute", top: 45, right: 8 }}
                    disabled={txn?.isPaid}
                  >
                    <DeleteOutlineIcon sx={{ color: "red" }} />
                  </IconButton>
                )}    
                {txn?.id && txn.paymentMethod !== EOIPaymentMode.GATEWAY &&(
                  <Box
                    sx={{
                      backgroundColor: bg,
                      color,
                      borderRadius: "6px",
                      px: 1.5,
                      py: 0.5,
                      fontWeight: 700,
                      fontSize: "14px",
                      mt: 1,
                      // mr: 5,
                      position: 'absolute',
                      top: 8,
                      right: 8,
                    }}
                  >
                    {text}
                  </Box>
                )}
              </Grid>

            </Grid>
          )}

          {/* Payment Method Options */}
          {!txn?.isPaid &&  !txn.id &&(
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                  Please select the payment method
                  <span className="asteriskColor"> *</span>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Box
                  onClick={() =>
                    setFieldValue(
                      `transactions[${index}].paymentMethod`,
                      EOIPaymentMode.GATEWAY
                    )
                  }
                  sx={{
                    width: "100%",
                    border:
                      txn.paymentMethod === EOIPaymentMode.GATEWAY
                        ? "rgba(0, 54, 140, 1)"
                        : "1px solid rgba(208, 213, 221, 1)",
                    textAlign: "center",
                    height: "42px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor:
                      txn.paymentMethod === EOIPaymentMode.GATEWAY
                        ? "rgba(26, 64, 125, 1)"
                        : "",
                    color:
                      txn.paymentMethod === EOIPaymentMode.GATEWAY
                        ? "#fff"
                        : "#1A407D",
                    fontWeight: 500,
                    cursor: "pointer",
                  }}
                >
                  Pay Now
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  onClick={() =>
                   { setFieldValue(
                      `transactions[${index}].paymentMethod`,
                      EOIPaymentMode.OFFLINE
                    )
                    setFieldValue( `transactions[${index}].status`,
                     EOIFinanceStatus.UNVERIFIED)}
                  }
                  sx={{
                    width: "100%",
                    border:
                      txn.paymentMethod === EOIPaymentMode.OFFLINE
                        ? "rgba(0, 54, 140, 1)"
                        : "1px solid rgba(208, 213, 221, 1)",
                    textAlign: "center",
                    height: "42px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor:
                      txn.paymentMethod === EOIPaymentMode.OFFLINE
                        ? "rgba(26, 64, 125, 1)"
                        : "",
                    color:
                      txn.paymentMethod === EOIPaymentMode.OFFLINE
                        ? "#fff"
                        : "#1A407D",
                    fontWeight: 500,
                    cursor: "pointer",
                  }}
                >
                  Pay Offline
                </Box>
              </Grid>
            </Grid>
          )}
          <FormHelperText error>
            {paymentOptionsFormik?.touched?.transactions?.[index]?.paymentMethod
              ? paymentOptionsFormik?.errors?.transactions?.[index]
                  ?.paymentMethod
              : ""}
          </FormHelperText>

          {txn.paymentMethod === EOIPaymentMode.GATEWAY && txn?.isPaid && (
            <PaymentCard
              key={txn?.index}
              amount={txn?.amount}
              date={formatDateIST(txn?.date)}
              method={txn?.onlineMethod?.toUpperCase()}
              status={txn?.status}
              transactionId={txn?.gatewayPaymentId}
            />
          )}

          {/* Online Payment Fields */}
          {txn.paymentMethod === EOIPaymentMode.GATEWAY && !txn?.isPaid && (
            <Grid container item xs={12} sm={6} spacing={2} mt={0}>
              {/* Amount Input */}
              <Grid item xs={12} sm={9}>
                <TextFieldInput
                  field={{
                    name: `transactions[${index}].amount`,
                    label: "Amount",
                    required: true,
                    readonly: txn?.isPaid ? true : false,
                    placeholder: "Enter amount",
                    maxLength: 15,
                    handleOnChange: (e) =>
                      handleInputFilter(e, index, "amount", "numbers"),
                    value: txn.amount || "",
                  }}
                  formik={paymentOptionsFormik}
                />
                <FormHelperText error>
                  {paymentOptionsFormik?.touched?.transactions?.[index]?.amount
                    ? paymentOptionsFormik?.errors?.transactions?.[index]
                        ?.amount
                    : ""}
                  {!paymentOptionsFormik?.errors?.transactions?.[index]
                    ?.amount &&
                  paymentOptionsFormik?.touched?.transactions?.[index]?.isPaid
                    ? paymentOptionsFormik?.errors?.transactions?.[index]
                        ?.isPaid
                    : ""}
                </FormHelperText>
              </Grid>

              {/* Proceed Button */}
              <Grid item xs={12} sm={3} mt={{ xs: 1, sm: 3.5 }}>
                <Button
                  variant="contained"
                      size="large"
                      sx={{
                        backgroundColor: "rgba(26, 64, 125, 1)",
                        borderRadius: "8px",
                        color: "#fff",
                        textTransform: "none",
                        cursor: "pointer",
                        minWidth: "120px",
                        maxHeight: "44px",
                        "&:hover": {
                          backgroundColor: "#092552",
                        color: "#fff", // slightly lighter or darker for hover
                      },
                    }}
                    onClick={() => isPayViaEasebuzz ? handleEasebuzzPay(txn.amount, index) : handleRazorPay(txn.amount, index)}
                    disabled={txn?.isPaid || !txn.amount || txn?.amount <= 0}
                  >
                    {payButtonLoading ? (
                      <CircularProgress size={24} sx={{ color: "white" }} />
                    ) : (
                      'Proceed'
                    )}
                  </Button>
              </Grid>
            </Grid>
          )}

          {/* Offline Payment Fields */}
          {txn.paymentMethod === EOIPaymentMode.OFFLINE && (
            <>
              <Grid item xs={12} mt={3}>
                <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                  Please select the payment method
                  <span className="asteriskColor"> *</span>
                </Typography>
              </Grid>
              <RadioGroup
                name={`transactions[${index}].offlineRadioOptions`}
                value={txn.offlineRadioOptions}
                onChange={(e) =>{
                   setFieldValue(
                    `transactions[${index}].offlineRadioOptions`,
                    e.target.value)
                    if(e.target.value ==='CHEQUE'){
                      setFieldValue(
                        `transactions[${index}].date`,
                        null)
                    }
                }}
                sx={{ mt: 0, ml: 1 }}
              >
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                  <FormControlLabel
                    value="CHEQUE"
                    control={<Radio />}
                    label="Cheque/DD"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "14px",
                        fontWeight: 400,
                      },
                    }}
                    disabled={isDisabled}
                  />
                  <FormControlLabel
                    value="ONLINE TRANSFER"
                    control={<Radio />}
                    label="Online Fund Transfer (NEFT/IMPS/RTGS)"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "14px",
                        fontWeight: 400,
                      },
                    }}
                    disabled={isDisabled}
                  />
                  <FormControlLabel
                    value="UPI CARD"
                    control={<Radio />}
                    label="UPI"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "14px",
                        fontWeight: 400,
                      },
                    }}
                    disabled={isDisabled}
                  />
                  <FormControlLabel
                    value="EDC MACHINE"
                    control={<Radio />}
                    label="EDC Machine"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "14px",
                        fontWeight: 400,
                      },
                    }}
                    disabled={isDisabled}
                  />
                </Box>
              </RadioGroup>
              <FormHelperText error>
                {paymentOptionsFormik?.touched?.transactions?.[index]
                  ?.offlineRadioOptions
                  ? paymentOptionsFormik?.errors?.transactions?.[index]
                      ?.offlineRadioOptions
                  : ""}
              </FormHelperText>

              <Box>
                {/* Transaction Details */}
                <Grid container spacing={2} mt={0}>
                  <Grid item xs={12} sm={6}>
                    <TextFieldInput
                      field={{
                        name: `transactions[${index}].transactionNo`,
                        label: getLabel(txn.offlineRadioOptions)?.firstField
                          .label,
                        placeholder: getLabel(txn.offlineRadioOptions)
                          ?.firstField.placeholder,
                        required: true,
                        handleOnChange: (e) =>
                          handleInputFilter(
                            e,
                            index,
                            "transactionNo",
                            "noSpaces"
                          ),
                        value: txn.transactionNo || "",
                        maxLength: 30,
                        readonly: isDisabled,
                      }}
                      formik={paymentOptionsFormik}
                    />
                    <FormHelperText error>
                      {paymentOptionsFormik?.touched?.transactions?.[index]
                        ?.transactionNo
                        ? paymentOptionsFormik?.errors?.transactions?.[index]
                            ?.transactionNo
                        : ""}
                    </FormHelperText>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                      <CustomDatePicker
                        minDate={dayjs().subtract(90, "day")}
                        maxDate={dayjs()}
                        label={txn.offlineRadioOptions === 'CHEQUE' ? " Cheque Date" : "Transaction Date"}
                        value={
                          paymentOptionsFormik?.values?.transactions?.[index]
                            ?.date
                        }
                        onChange={(val) => {
                          handleDateChange(val.target.value, index, txn.offlineRadioOptions)
                        }}
                        name={`transactions[${index}].date`}
                        error={
                          paymentOptionsFormik?.touched?.transactions?.[index]
                            ?.date &&
                          Boolean(
                            paymentOptionsFormik?.errors?.transactions?.[index]
                              ?.date
                          )
                      }
                      helperText={
                        paymentOptionsFormik?.touched?.transactions?.[index]
                          ?.date
                          ? paymentOptionsFormik?.errors?.transactions?.[index]
                              ?.date
                          : ""
                      }
                      required={true}
                      disabled={isDisabled}
                    />
                  </Grid>
                  
                  { txn.offlineRadioOptions ==='CHEQUE' && <Grid item xs={12} sm={6}>
                    <TextFieldInput
                      field={{
                        name: `transactions[${index}].bankName`,
                        label: getLabel(txn.offlineRadioOptions)?.secondField
                          .label,
                        placeholder: getLabel(txn.offlineRadioOptions)
                          ?.secondField.placeholder,
                        required: true,
                        handleOnChange: (e) =>
                          handleInputFilter(e, index, "bankName", "alphabets"),
                        value: txn.bankName || "",
                        maxLength: 50,
                        readonly: isDisabled,
                      }}
                      formik={paymentOptionsFormik}
                    />
                    <FormHelperText error>
                      {paymentOptionsFormik?.touched?.transactions?.[index]
                        ?.bankName
                        ? paymentOptionsFormik?.errors?.transactions?.[index]
                            ?.bankName
                        : ""}
                    </FormHelperText>
                  </Grid>}
                    <Grid item xs={12} sm={6}>
                    <TextFieldInput
                      field={{
                        name: `transactions[${index}].amount`,
                        label: "Amount",
                        required: true,
                        placeholder: "Enter amount",
                        maxLength: 15,
                        handleOnChange: (e) =>
                          handleInputFilter(e, index, "amount", "numbers"),
                        value: txn.amount || "",
                        readonly: isDisabled,
                      }}
                      formik={paymentOptionsFormik}
                    />
                    <FormHelperText error>
                      {paymentOptionsFormik?.touched?.transactions?.[index]
                        ?.amount
                        ? paymentOptionsFormik?.errors?.transactions?.[index]
                            ?.amount
                        : ""}
                    </FormHelperText>
                  </Grid>
                  <Grid item xs={12} sm={6} className="widthFullUploadInput">
                    <UploadInput
                      paymentProof={true}
                      index={index}
                      field={{
                        name: "paymentProof",
                        label: "Payment Proof",
                        required: true,
                        readonly: false,
                        placeholderUpload: "Payment Proof Uploaded",
                        placeholder: paymentOptionsFormik?.values?.transactions[
                          index
                        ]?.isPhysicalPaymentProof
                          ? "Upload Later"
                          : "Upload Payment Proof",
                        physicalCopyValue:
                          paymentOptionsFormik?.values?.transactions[index]
                            ?.isPhysicalPaymentProof,
                        handleOnClick: () => toggleTransactionScreenshot(index),
                      }}
                      formik={paymentOptionsFormik}
                      disabled={isDisabled}
                    />
                    <FormHelperText error>
                      {paymentOptionsFormik?.touched?.transactions?.[index]
                        ?.paymentProof
                        ? paymentOptionsFormik?.errors?.transactions?.[index]
                            ?.paymentProof
                        : ""}
                    </FormHelperText>
                  </Grid>
                </Grid>

                {/* <Grid container spacing={2} mt={0}>
                  <Grid item xs={12} sm={6}>
                    <TextFieldInput
                      field={{
                        name: `transactions[${index}].branchName`,
                        label: getLabel(txn.offlineRadioOptions)?.thirdField
                          .label,
                        placeholder: getLabel(txn.offlineRadioOptions)
                          ?.thirdField.placeholder,
                        required: true,
                        handleOnChange: (e) =>
                          handleInputFilter(
                            e,
                            index,
                            "branchName",
                            "alphabets"
                          ),
                        value: txn.branchName || "",
                        maxLength: 50,
                      }}
                      formik={paymentOptionsFormik}
                    />
                    <FormHelperText error>
                      {paymentOptionsFormik?.touched?.transactions?.[index]
                        ?.branchName
                        ? paymentOptionsFormik?.errors?.transactions?.[index]
                            ?.branchName
                        : ""}
                    </FormHelperText>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextFieldInput
                      field={{
                        name: `transactions[${index}].accountNo`,
                        label: getLabel(txn.offlineRadioOptions)?.fourthField
                          .label,
                        placeholder: getLabel(txn.offlineRadioOptions)
                          ?.fourthField.placeholder,
                        required: true,
                        handleOnChange: (e) =>
                          handleInputFilter(e, index, "accountNo", "numbers"),
                        value: txn.accountNo || "",
                      }}
                      formik={paymentOptionsFormik}
                    />
                    <FormHelperText error>
                      {paymentOptionsFormik?.touched?.transactions?.[index]
                        ?.accountNo
                        ? paymentOptionsFormik?.errors?.transactions?.[index]
                            ?.accountNo
                        : ""}
                    </FormHelperText>
                  </Grid>
                </Grid> */}

                {/* Amount + Upload Proof */}
               
              </Box>
            </>
          )}

          {/* Add More Transactions */}
          {values?.transactions?.length - 1 === index && txn.paymentMethod && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "8px",
                color: "rgba(26, 64, 125, 1)",
                mt: 1,
              }}
            >
              <Button
                onClick={handleAddTransaction}
                disabled={
                  (!txn?.isPaid && txn.paymentMethod === EOIPaymentMode.GATEWAY) ||
                  paymentOptionsFormik?.values?.transactions?.length >= MAX_TRANSACTION_LIMIT
                }
              >
                <ControlPointIcon
                  sx={{
                    color:
                      (!txn?.isPaid && txn.paymentMethod === EOIPaymentMode.GATEWAY) ||
                      paymentOptionsFormik?.values?.transactions?.length >= MAX_TRANSACTION_LIMIT
                        ? "grey"
                        : "rgba(26, 64, 125, 1)",
                  }}
                />
                <Typography
                  sx={{
                    color:
                      (!txn?.isPaid && txn.paymentMethod === EOIPaymentMode.GATEWAY) ||
                      paymentOptionsFormik?.values?.transactions?.length >= MAX_TRANSACTION_LIMIT
                        ? "grey"
                        : "rgba(26, 64, 125, 1)",
                    fontSize: "14px",
                    fontWeight: "600",
                    textDecoration: "underline",
                    textTransform: "none",
                    cursor: "pointer",
                  }}
                >
                  Add multiple transactions
                </Typography>
              </Button>
            </Box>
          )}
            <PaymentFailedModal open={openPaymentFailedModal} onClose={() => { setOpenPaymentFailedModal(false) }} onProceed={(selectedGateway) => { handleProceedGateway(selectedGateway) }} />

            <ConfirmationModal
              open={chequeDateWarningModal}
              onClose={() => { setChequeDateWarningModal(false) }}
              title='Date Warning'
              subtitle={''}
              disableBackdropClick={true}
              hideCloseIcon={true}
              actions={
                <>
                  <Button
                    variant="contained"
                    sx={{
                      width: { xs: "100%", sm: "180px", md: "214px" },
                      height: "48px",
                      borderRadius: "8px",
                      padding: "12px 20px",
                      background: "#1A407D",
                      color: "#fff",
                      fontSize: "16px",
                      fontWeight: 600,
                      lineHeight: "24px",
                      textTransform: "capitalize",
                      "&:hover": { backgroundColor: "#092552" },
                    }}
                    onClick={() => { setChequeDateWarningModal(false) }}
                  >
                    Okay
                  </Button>

                </>
              }
            >
              <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, paddingTop: '10px', paddingBottom: '10px' }}>
                <Typography>Since it is a post-dated cheque, the Queue ID will be assigned once the payment is realized & Confirmed by finance.</Typography>
              </Box>
            </ConfirmationModal>
            {txn.showUploadPopup && (
            <UploadPopup
              heading="Upload Your Transaction Screenshot"
              totalImages={1}
              voucherMutliUpload={true}
              handleImageValue={(keyName, imgName) =>
                handleImageValue(index, keyName, imgName, true)
              }
              uploadedImage={
                paymentOptionsFormik?.values?.transactions[index]?.paymentProof
              }
              fieldName="paymentProof"
              handleUpdateImageData={(fieldName, imageData) =>
                handleUpdateImageData(index, fieldName, imageData)
              }
              handlePhysicalImage={(fieldName, value) => {
                handlePhysicalImage(index, fieldName, value);
              }}
              selectedOptionValue={
                paymentOptionsFormik?.values?.transactions[index]
                  .isPhysicalPaymentProof
              }
              disabled={isDisabled}
              closePopup={()=>{toggleTransactionScreenshot(index)}}
            />
          )}
        </Box>
      )})}
    </>
  );
};

export default MultiTransaction;
